import React, { useLayoutEffect } from 'react';
import "../Css/AboutPage.css";
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import Footer from '../Component/Footer/Footer';
import image01 from "../Images/aboutPage/about_us_01.webp";
import image02 from "../Images/aboutPage/about_02.png";
import image03 from "../Images/aboutPage/about_03.jpg";
const AboutPage = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});
  return (
    <div>
      <section className='about-section-banner'>
        <div className='container'>
          <div className='about-section-banner-main-con'>
            <div className='about-section-banner-con'>
              <h2>about us</h2>
              <div className='about-section-banner-content'>
                <FaHome />
                <IoIosArrowForward />
                <span>
                  about us
                </span>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className='about-page-section-1'>
        <div className='container'>
          <div className='about-page-section-1-main-con'>
            <div className='about-page-section-image-main-con'>
<img src={image01}/>
            </div>
            <p>At Woodsy, we bring the beauty of nature into your spaces with premium, sustainable wood products. From elegant veneers to strong timber, our materials are crafted to meet modern design needs. Known as the Best plywood company in Byculla, Woodsy delivers quality, style, and eco-conscious solutions for timeless wooden interiors.  We provide premium plywood and veneers that are trusted for quality and durability. As the best plywood company in Byculla, we ensure excellence always.</p>
          </div>
          <div className='about-page-section-1-second-con'>
            <div className='about-page-section-1-second-image-main-con'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='about-page-section-1-second-image-details-1-con'>
                    <div className='about-page-section-1-dsecond-image-con'>
                      <img src={image02}/>
                    </div>
                    <h3>About our shop</h3>
                    <p>Our store specializes in high-quality wood goods and provides a carefully chosen selection of panels, veneers, and plywood. Each product blends strength, beauty, and dependability and is carefully designed and sourced. We assist you in confidently building with materials that enhance every area of your room, whether it be for flooring, walls, or furniture. Offering high-quality wood products, we deliver strength and style. Known as the Best plywood company in Byculla, we focus on customer satisfaction.</p>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='about-page-section-1-second-image-details-1-con'>
                    <div className='about-page-section-1-dsecond-image-con'>
                      <img src={image03}/>
                    </div>
                    <h3>What we do</h3>
                    <p>As the best plywood company in Byculla, we offer wood materials that are both stylish and long-lasting. Our specialty is locating and supplying panels, veneers, and plywood that improve any area. With a focus on quality, we provide wood items that are meant to inspire and last to homeowners, contractors, and interior designers. From plywood to veneers, our wood solutions combine durability and design. Recognized as the Best plywood company in Byculla, we serve you best.</p>
                    <p className='d-none'> Our business provides high-quality, long-lasting wood products, such as plywood, veneers, and timber panels, to meet a variety of design requirements. We provide high-quality materials that improve interior aesthetics and endure normal wear and tear, catering to builders, designers, and homeowners. We meticulously source and inspect all materials as part of our commitment to sustainability. Our knowledgeable staff makes sure you select the best wood for your project by offering individualized advice and trustworthy service. Whether building a new house or remodeling an existing one, we provide durable, eye-catching wood solutions that exquisitely alter any area.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  )
}

export default AboutPage
